import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { RiunioneRequest } from '../components/pratica/pratiche-riunite/riunione-request';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { FascicoloGiudiziale } from '../models/fascicolo/fascicolo-giudiziale';
import { BaseForm } from './base-Form';

@Component({
    selector: 'div [riunione-giudizi-form]',
  templateUrl: 'riunione-giudizi-form.html'
})

export abstract class RiunioneGiudiziForm extends BaseForm {

  fascicoloCapofila: FascicoloGiudiziale;
  fascicoliRiuniti: FascicoloFull[];
  request: RiunioneRequest;
  riunioneGiudiziForm: FormGroup;

  abstract datiRiunione(response);

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

 initRequest() {
    this.request = new RiunioneRequest();
    this.request.fascicoloCapofila = this.fascicoloCapofila;
    this.request.motivoRiunione = this.fascicoloCapofila.motivoRiunione;
    this.request.dataRiunione = this.fascicoloCapofila.dataRiunione;
   }

  createForm() {
    this.initRequest();
    this.riunioneGiudiziForm = this.campiForm.group({
      dataRiunione: [this.request.dataRiunione, Validators.required],
      motivoRiunione: [this.request.motivoRiunione, Validators.required]
    });
  }

  save() {
    this.operationService.updateRiunioneGiudizio(this.request).
      subscribe(response => this.datiRiunione(response));
  }

}
